import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { createTracker } from 'redux-segment';
import { pageMapper } from '@surfline/web-common/dist/segment';
import rootReducer from '../reducers';

export default function configureStore(initialState, history) {
  const enhancer = compose(
    applyMiddleware(thunk, createTracker(pageMapper), routerMiddleware(history))
  );
  const store = createStore(rootReducer(history), initialState, enhancer);
  return store;
}
